import { render, staticRenderFns } from "./SimpleImage.vue?vue&type=template&id=53127348&"
import script from "./SimpleImage.vue?vue&type=script&lang=js&"
export * from "./SimpleImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports